const ADMIN = 1;
const USER = 0;
const SUPER_ADMIN = 2;

export { ADMIN, USER, SUPER_ADMIN };
